<script lang="ts">
	import { format } from 'svelte-i18n';
	//stores
	import { includingDeviceData } from 'src/stores/features/inclusion';
	//helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Design system components
	import { CardGrid, SelectCard, Text } from '@Shelly/shelly-design-system';
	import { bluetooth } from 'src/stores/session/native-bridge';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let inclusionData;

	const selectTypeOptions = {
		ble: {
			icon: 'fal fa-bluetooth',
			title: capFirstChar($format('via_ble_scan', { default: 'Add via Bluetooth' })),
			descriptiveText: $format('via_ble_scan_description', {
				default:
					'Use Bluetooth to set up and add devices to your account. Recommended for Generation 2 Shelly devices.',
			}),
			disabled: false,
		},
		wifi: {
			icon: 'fal fa-wifi',
			title: capFirstChar($format('via_ap_scan', { default: 'Add via Wi-Fi (AP Scan)' })),
			descriptiveText: $format('via_ap_scan_description', {
				default:
					'Use Wi-Fi Access Point to set up and add devices to your account. Relevant for Generation 1 Shelly devices.',
			}),
			disabled: false,
		},
		wifi_scan: {
			icon: 'fal fa-router',
			title: capFirstChar(
				$format('via_wifi_scan', {
					default: 'Scan Network',
				}),
			),
			descriptiveText: $format('via_scan_wifi_description', {
				default: 'Scan your current network for Shelly devices.',
			}),
			disabled: false,
		},
	};

	const handleTypeSelection = (type) => {
		if (import.meta.env.DEV) console.log('handleTypeSelection', type);
		inclusionData.selected = undefined;
		includingDeviceData.reset(); //resetting device object because bluetooth device list wont display devices if user gets back to type select page from including device step
		inclusionData.selectVia = type;
	};
</script>

<Text element="h2" class="mb-s">
	{capFirstChar(
		$format('text_title_inclusion_via', {
			default: 'Inclusion type',
		}),
	)}
</Text>
<Text class="mb-m" styleType="body-small">
	{capFirstChar(
		$format('text_body_inclusion_via', {
			default: 'Select how you want to include your device to the local network.',
		}),
	)}
</Text>

<CardGrid lg={290} sm={270} modalContent gridGap="s" noPaddingBottom>
	{#each Object.values(selectTypeOptions) as { title, icon, disabled, descriptiveText }, i}
		<div class="d-flex">
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				type="horizontal"
				{descriptiveText}
				{title}
				selected={inclusionData?.selectVia == Object.keys(selectTypeOptions)[i]}
				variant="radio"
				{icon}
				class="width-full"
				{disabled}
				error={Object.keys(selectTypeOptions)[i] === 'ble' &&
				['unauthorised', 'unauthorized'].includes($bluetooth)
					? $format('device_bluetooth_access_denied', {
							default: 'Bluetooth access denied',
						})
					: Object.keys(selectTypeOptions)[i] === 'ble' && $bluetooth === 'poweredOff'
						? $format('device_bluetooth_disabled', {
								default: 'Bluetooth disabled',
							})
						: null}
				on:click={() => handleTypeSelection(Object.keys(selectTypeOptions)[i])}
			/>
		</div>
	{/each}
</CardGrid>
